import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import StandardTable from '@/components/table/StandardTable';
var columns = [
// {
//   title:"id",
//   dataIndex: 'id',
//   show:false
// },
{
  title: '部门',
  dataIndex: 'dept'
}, {
  title: '预算年份',
  dataIndex: 'ysnf'
}, {
  title: '预算总额',
  dataIndex: 'ysze'
}, {
  title: '已花费预算',
  dataIndex: 'yhfys'
}, {
  title: '剩余预算',
  dataIndex: 'syys'
}, {
  title: '创建人',
  dataIndex: 'cjr'
}, {
  title: '创建时间',
  dataIndex: 'cjsj'
}, {
  title: '操作',
  scopedSlots: {
    customRender: 'action'
  }
}];
var dataSource = [{
  id: 999,
  dept: '财务室',
  ysnf: '2019',
  ysze: '10000.00',
  yhfys: '50.00',
  syys: '9950.00',
  cjr: '张三',
  cjsj: '2019-06-01 11:55:32'
}];
for (var i = 0; i < 100; i++) {
  dataSource.push({
    id: i,
    dept: '财务室' + i,
    ysnf: '2019',
    ysze: '10000.00',
    yhfys: '50.00',
    syys: '9950.00',
    cjr: '张三',
    cjsj: '2019-06-01 11:55:32'
  });
}
export default {
  components: {
    StandardTable: StandardTable
  },
  name: 'deptBudget',
  data: function data() {
    return {
      yearShowOne: false,
      drawerYearShowOne: false,
      queryParam: {
        deptName: '',
        year: '',
        publisher: ''
      },
      selectedRows: [],
      columns: columns,
      ischeck: true,
      infoView: false,
      drawerTitle: '新增',
      dataSource: dataSource,
      deptBudgetForm: {
        type: 0,
        dept: '',
        ysnf: '',
        ysze: '',
        yhfys: '',
        syys: '',
        cjr: '',
        cjsj: '',
        rules: {
          ysze: [{
            require: true
          }]
        }
      }
    };
  },
  methods: {
    openChangeOne: function openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne: function panelChangeOne(value) {
      this.queryParam.year = value.format('YYYY');
      this.yearShowOne = false;
    },
    openChangeOneView: function openChangeOneView(status) {
      if (status) {
        this.drawerYearShowOne = true;
      }
    },
    panelChangeOneView: function panelChangeOneView(value) {
      this.deptBudgetForm.ysnf = value.format('YYYY');
      this.drawerYearShowOne = false;
    },
    resetQueryParam: function resetQueryParam() {
      this.queryParam.deptName = '';
      this.queryParam.year = '';
      this.queryParam.publisher = '';
    },
    addView: function addView() {
      this.drawerTitle = '新增';
      this.deptBudgetForm.type = 1;
      this.infoView = true;
    },
    editView: function editView() {
      this.drawerTitle = '调整';
      this.deptBudgetForm.type = 2;
      this.infoView = true;
    },
    deleteRecord: function deleteRecord(key) {
      this.dataSource = this.dataSource.filter(function (item) {
        return item.id !== key;
      });
      this.selectedRows = this.selectedRows.filter(function (item) {
        return item.id !== key;
      });
    },
    onClose: function onClose() {
      this.infoView = false;
    },
    countMoney: function countMoney() {
      if (this.deptBudgetForm.ysze < this.deptBudgetForm.yhfys) {}
    }
  },
  mounted: function mounted() {
    var _this = this;
    document.body.addEventListener('click', function () {
      _this.yearShowOne = false;
      _this.drawerYearShowOne = false;
    }, false);
  }
};